import type {
  CreatePersonInput,
  UpdatePersonInput,
  PersonFormDto,
} from '../../shared';
import {
  required,
  schema,
  maxLength,
  email as emailValidator,
} from '@angular/forms/signals';

// Type that matches createPersonSchema from shared validators
export type CreatePersonPayload = CreatePersonInput;

export type UpdatePersonPayload = UpdatePersonInput;

export const personFormSchema = schema<PersonFormDto>((path) => {
  maxLength(path.title, 10, {
    message: 'common.form.validation.titleMaxLength10',
  });

  required(path.firstName, {
    message: 'common.form.validation.firstNameRequired',
  });
  maxLength(path.firstName, 100, {
    message: 'common.form.validation.firstNameMaxLength100',
  });

  required(path.lastName, {
    message: 'common.form.validation.lastNameRequired',
  });
  maxLength(path.lastName, 100, {
    message: 'common.form.validation.lastNameMaxLength100',
  });

  required(path.email, { message: 'common.form.validation.emailRequired' });
  maxLength(path.email, 255, {
    message: 'common.form.validation.emailMaxLength',
  });
  emailValidator(path.email, {
    message: 'common.form.validation.emailInvalid',
  });

  maxLength(path.phone, 30, {
    message: 'common.form.validation.phoneMaxLength',
  });

  maxLength(path.privateMobile, 30, {
    message: 'common.form.validation.phoneMaxLength',
  });

  maxLength(path.street, 255, {
    message: 'persons.form.validation.streetMaxLength',
  });

  maxLength(path.postalCode, 20, {
    message: 'persons.form.validation.postalCodeMaxLength',
  });

  maxLength(path.city, 100, {
    message: 'persons.form.validation.cityMaxLength',
  });

  maxLength(path.country, 100, {
    message: 'persons.form.validation.countryMaxLength',
  });

  maxLength(path.socialSecurityNumber, 50, {
    message: 'persons.form.validation.socialSecurityNumberMaxLength',
  });

  maxLength(path.personnelNumber, 50, {
    message: 'persons.form.validation.personnelNumberMaxLength',
  });

  maxLength(path.company, 255, {
    message: 'common.form.validation.companyMaxLength',
  });

  required(path.type, { message: 'common.form.validation.typeRequired' });

  maxLength(path.tags, 1000, {
    message: 'common.form.validation.maxLength1000',
  });
  maxLength(path.additionalEmail, 255, {
    message: 'common.form.validation.emailMaxLength',
  });
  emailValidator(path.additionalEmail, {
    message: 'common.form.validation.emailInvalid',
  });
});
